import { useSelector } from 'Hooks';

// Checks if current integrations contain specified provider, and is active
// Provider example: 'SKATTEVERKET'
export const hasActiveIntegration = (provider: string): boolean => {
  const integrations = useSelector((state) => state.integrations);
  if (!integrations) {
    return false;
  }
  const foundIntegration = integrations.companyIntegrations.find(
    (integration) => integration.provider === provider,
  );
  return foundIntegration ? foundIntegration.isActive : false;
};
